import React from 'react';

export class ArrowIcon extends React.Component<{}, {}> {
    render(): JSX.Element {
        return (
            <svg viewBox="0 0 15.1 8.9">
                <polygon points="0.2,1.4 7.6,8.9 15.1,1.4 13.7,0 7.6,6 1.6,0"/>
            </svg>
        );
    }
}
